import type { HandlingUnitHashMap } from "@RequestFormV2/sections/PackingList/types";
import {
  formatCustomFieldDisplayValue,
  getCustomFieldLabel,
  getPersistedCustomFieldValue,
  isCustomFieldEnabledForItem,
  type CustomFieldDisplayItem,
} from "@RequestFormV2/sections/PackingList/utils/customFieldDisplay";

type CustomFieldDisplayCellProps = {
  item: CustomFieldDisplayItem;
  handlingUnitHashMap: HandlingUnitHashMap;
};

export default function CustomFieldDisplayCell({
  item,
  handlingUnitHashMap,
}: Readonly<CustomFieldDisplayCellProps>) {
  const enabled = isCustomFieldEnabledForItem(item, handlingUnitHashMap);
  const value = getPersistedCustomFieldValue(item);
  const label = getCustomFieldLabel(item, handlingUnitHashMap);

  if (!enabled && !value) {
    return <span>{formatCustomFieldDisplayValue("")}</span>;
  }

  return (
    <div className="rfv2-review-packing-list__custom-field-cell">
      {label ? <span className="rfv2-review-packing-list__unit-cell-label">{label}</span> : null}
      <span className="rfv2-review-packing-list__unit-cell-line">{formatCustomFieldDisplayValue(value)}</span>
    </div>
  );
}
